export default __webpack_public_path__ + "static/media/suit-5.4fd7eb8e.jpg";